module.exports = "/images/camera-icon.svg?592e504b0ecc3b0d51ac49f21b43965c";